import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { Button } from 'react-bootstrap'
import { Link } from 'gatsby'

import xcadCoin from '~img/icons/xcad-coin.svg'

import * as s from './HeaderActionLinks.module.scss'

const HeaderActionLinks = (props) => {
  const {
    primaryText,
    primaryLink,
    secondaryText,
    secondaryLink,
    className,
    variant,
    ...rest
  } = props

  return (
    <div
      {...rest}
      className={cn(s.headerActionLinks, { [s[variant]]: variant }, className)}
    >
      {!!secondaryLink && (
        <Button
          to={secondaryLink.to}
          as={Link}
          variant="outline-black"
          className="btn-with-icon"
          activeClassName="active"
          aria-label={secondaryLink.title}
        >
          Buy <img src={xcadCoin} alt="xcad coin" /> XCAD
        </Button>
      )}

      <Button
        to={primaryLink.to}
        aria-label={primaryLink.title}
        // disabled={isDisabled}
        variant="solid-black"
        as={Link}
      >
        {primaryText}
      </Button>
    </div>
  )
}

HeaderActionLinks.defaultProps = {
  className: undefined,
  variant: undefined,
  secondaryLink: undefined,
}

HeaderActionLinks.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.oneOf(['mobile']),
  primaryText: PropTypes.string.isRequired,
  secondaryText: PropTypes.string.isRequired,
  primaryLink: PropTypes.shape({
    id: PropTypes.string,
    to: PropTypes.string,
    title: PropTypes.string,
    text: PropTypes.string,
  }).isRequired,
  secondaryLink: PropTypes.shape({
    id: PropTypes.string,
    to: PropTypes.string,
    title: PropTypes.string,
    text: PropTypes.string,
  }),
}

export default HeaderActionLinks
